import {
  getStatus,
  getIconType,
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

const toStr = (v) => (v == null ? '' : String(v).trim());
const toNonEmptyStr = (v) => {
  const s = toStr(v);
  return s ? s : '';
};

const toNonNegativeInt = (n) => {
  const num = Number(n);
  if (!Number.isFinite(num)) return null;
  const int = Math.trunc(num);
  return int >= 0 ? int : null;
};

const getField = (obj, keys) => {
  if (!obj || typeof obj !== 'object') return '';
  for (const k of keys) {
    const v = obj?.[k];
    const s = toNonEmptyStr(v);
    if (s) return s;
  }
  return '';
};

/**
 * Transforms local_directories criteria.
 * Legacy JS shows listings only when at least one of: page_link/address/phone/reviews_count exists.
 *
 * @param {Object} localDirectoriesCriteria - criteria.local_directories
 * @returns {Object} transformed criteria
 */
export const transformLocalDirectories = (localDirectoriesCriteria) => {
  if (!localDirectoriesCriteria) {
    return {
      status: 'error',
      iconType: 'error',
      importance: { level: 0, text: '' },
      solvability: { level: 0, text: '' },
      isEmpty: true,
      message: 'No Local Directories were found.',
      data: null,
    };
  }

  const wooRankStatus = localDirectoriesCriteria?.status || 'neutral';
  const importance = localDirectoriesCriteria?.importance || 0;
  const solvability = localDirectoriesCriteria?.solvability || 0;

  const rawMap = localDirectoriesCriteria?.data;
  const map = rawMap && typeof rawMap === 'object' && !Array.isArray(rawMap) ? rawMap : {};

  const listings = Object.entries(map)
    .map(([directoryName, value]) => {
      if (!value || typeof value !== 'object') return null;

      const pageLink = getField(value, ['page_link', 'pageLink', 'url', 'link', 'listing_url', 'listingUrl']);
      const name = getField(value, ['name', 'business_name', 'businessName', 'title']);
      const address = getField(value, ['address', 'location', 'street', 'fullAddress']);
      const phone = getField(value, ['phone', 'phone_number', 'phoneNumber', 'tel']);

      const reviewsCountRaw = value?.reviews_count ?? value?.reviewsCount ?? value?.review_count ?? value?.reviewCount;
      const reviewsCount = toNonNegativeInt(reviewsCountRaw);

      const reviewsLink = getField(value, ['reviews_link', 'reviewsLink']) || pageLink;

      // Legacy requires at least one "attribute" to show the listing (directory/name alone doesn't count).
      const hasAnyAttribute = Boolean(pageLink || address || phone || (reviewsCount != null));
      if (!hasAnyAttribute) return null;

      return {
        directoryName: toStr(directoryName),
        name,
        pageLink,
        address,
        phone,
        reviewsCount,
        reviewsLink,
      };
    })
    .filter(Boolean);

  const isEmpty = listings.length === 0;

  return {
    status: getStatus(wooRankStatus),
    iconType: getIconType(wooRankStatus),
    importance: getImportance(importance),
    solvability: getSolvability(solvability),
    isEmpty,
    message: isEmpty ? 'No Local Directories were found.' : null,
    data: isEmpty ? null : { listings },
  };
};

export default transformLocalDirectories;


